export default {
    singleImageView: {
        height: "100%",
        width: "100%",
        backgroundSize: "cover",
        backgroundRepeat: "no-repeat",
        backgroundPosition: "center",
        transition: "all 0.4s linear"
    },

    paperContainer: {
        position: "absolute",
        top: 0,
        left: 0,
        margin: 0,
        cursor: "default",
        transition: "transform 0s",
        overflow: "visible",
        borderRadius: 8,
        boxShadow: "0 4px 20px rgba(0,0,0,0.2)"
    },

    dialogHeader: {
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        padding: "8px 16px",
        background: "#f8f9fa",
        cursor: "grab",
        borderBottom: "1px solid #ddd",
        userSelect: "none"
    },

    dialogContent: {
        position: "relative",
        padding: "16px",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        maxWidth: "90vw",
        maxHeight: "80vh",
        overflow: "auto"
    },

    imageContainer: {
        position: "relative",
        display: "inline-block"
    },

    previewImage: {
        maxWidth: "800px",
        maxHeight: "600px",
        transition: "transform 0.3s",
        display: "block"
    },

    // For the thumbnail/preview box (keeping makeStyles for now or convert to sx)
    imageController: {
        overflow: "hidden",
        width: "100%",
        position: "relative",
        cursor: "pointer",
        "&:hover": {
            opacity: 0.8
        }
    },

    rotateLeftIcon: {
        backgroundColor: "#fff",
        borderRadius: "20px",
        boxShadow: "1px 2px 10px 0px #165550",
        bottom: 0,
        left: "2%",
        margin: "auto",
        position: "absolute",
        top: 0,
        zIndex: 2
    },
    rotateRightIcon: {
        backgroundColor: "#fff",
        borderRadius: "20px",
        boxShadow: "1px 2px 10px 0px #165550",
        bottom: 0,
        margin: "auto",
        position: "absolute",
        right: "2%",
        top: 0,
        zIndex: 2
    }
};
